"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNative = require("react-native");

var _Text = _interopRequireDefault(require("../Text"));

var _Image = _interopRequireDefault(require("../Image"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Style = _reactNative.StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingVertical: 10
  },
  image: {
    width: '90%',
    height: 150,
    borderRadius: 4,
    resizeMode: 'contain'
  },
  info: {
    flexDirection: 'column',
    paddingVertical: 10
  }
});

var _default = function _default(_ref) {
  var product = _ref.product,
      style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.ScrollView, {
    contentContainerStyle: [Style.container, style]
  }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    media: product.photo,
    style: Style.image
  }), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: Style.info
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: Style.name,
    bold: true
  }, product.name)), /*#__PURE__*/_react["default"].createElement(_Text["default"], null, product.code));
};

exports["default"] = _default;